import { IFSecure } from "@nju/data-access-portal-product";
import { IconName } from "@nju/icons";
import { differenceInCalendarDays, formatDate } from "@nju/utils";
import { IServiceCTABannerConditions } from "./types";

interface IStatusProps {
  title: string;
  text: string;
  iconName: IconName;
}

interface IGetStatusProps {
  anniversaryDate: string | undefined;
  conditions: IServiceCTABannerConditions;
  access: IFSecure | undefined;
}

export function getFSecureStatusData({
  conditions,
  anniversaryDate,
  access,
}: IGetStatusProps): IStatusProps | undefined {
  const { isPendingTermination, isSuspended, isPendingReactivation } =
    conditions;

  if (isPendingTermination && anniversaryDate) {
    const time = formatDate(anniversaryDate, false);
    const diffDays = differenceInCalendarDays(anniversaryDate);
    return {
      title: `usługa zostanie zakończona za ${diffDays} dni (${time})`,
      text: `Twoja usługa Bezpieczny internet będzie aktywna do ${time}.`,
      iconName: "exclamation-circle",
    };
  }

  if (isSuspended && access?.statusChangeDate && access?.terminationDate) {
    const time = formatDate(access.statusChangeDate, false);
    const terminationDate = formatDate(access.terminationDate, false);

    return {
      title: "usługa została wyłączona",
      text: `${time} Bezpieczny internet został wyłączony ze względu na brak płatności. Możesz go ponownie włączyć, gdy opłacisz usługę do ${terminationDate}. Po tej dacie stracisz dostęp.`,
      iconName: "exclamation-circle",
    };
  }

  if (isPendingReactivation) {
    return {
      title: "usługa w trakcie włączania",
      text: `Trwa ponowna aktywacja Twojej usługi.`,
      iconName: "spinner",
    };
  }

  return undefined;
}
